module.exports = __webpack_public_path__ + "static/img/m_name.84688a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/cz/m_name.png
// module id = qFqE
// module chunks = 7